/* eslint-disable no-unused-vars */
import { Divider, Spin, Table } from 'antd';
import { CourseScheduleWrapper } from './styled';
import { useEffect, useState } from 'react';
import Select from 'components/Select';
import images from 'assets/sheets/images';
import ChooseDate from 'components/ChooseDate/ChooseDate';
import Button from 'components/Button';
import Pagination from 'components/Pagination';
import ModalConfirmDeleteSchedule from './components/ModalConfirmDeleteSchedule';
import ModalConfirmChangeStatus from './components/ModalConfirmChangeStatus';
import ModalCourse from './components/ModalCourse';
import ModalCourseDetail from './components/ModalCourseDetail';
import ModalQRCode from './components/ModalQRCode';
import CourseScheduleServices from 'services/CourseScheduleServices';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, TIME_ZONE } from 'helper/init.constants';
import CourseServices from 'services/CourseServices';
import CustomEmptyDescription from 'components/CustomEmptyDescription';
import dayjs from 'dayjs';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';

export const AppState = {
  PUBLIC: '公開',
  PRIVATE: '非公開',
};
const initateForm = {
  search: '',
  page: DEFAULT_PAGE_NUMBER,
  pageSize: DEFAULT_PAGE_SIZE,
  status: 'ALL',
  currentCourseStatus: 'UPCOMING_COURSES',
  region: 'ALL',
  course: 'ALL',
  startTime: '',
  endTime: '',
  timezone: TIME_ZONE,
};

const initialSendEmailState = {
  email: '',
  subject: '',
  content: '',
};

export const clearAllFields = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== 'ALL'));
};

const CourseSchedule = () => {
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [form, setForm] = useState({ ...initateForm });
  const [sendEmailForm, setSendEmailForm] = useState(initialSendEmailState);
  const [loadingSendEmail, setLoadingSendEmail] = useState(false);
  const [isDelete, setIsDelete] = useState(null);
  const [isQRCode, setIsQRCode] = useState({
    courseId: null,
    state: false,
  });
  const [isEdit, setIsEdit] = useState(null);
  const [isChangeStatus, setIsChangeStatus] = useState(null);
  const [schedules, setSchedules] = useState([]);
  const [isAddCourse, setIsAddCourse] = useState(false);
  const [isCourseDetail, setIsCourseDetail] = useState(null);
  const [isSendEmailQRCode, setIsSendEmailQRCode] = useState({
    state: false,
    courseId: null,
    day: null,
  });

  const handleSetDelete = (id) => {
    const entry = schedules.items.find((item) => item._id === id);
    if (entry.totalRegistrations === 0) {
      setIsDelete(id);
    } else return;
  };

  const getListStudent = (courseId, body = {}) => {
    return CourseScheduleServices.getStudentList(courseId, body)
      .then((res) => {
        return res?.data?.items;
      })
      .catch((err) => {
        toast.error(err?.message || err || NO_INTERNET);
      });
  };

  const changeStatusDirect = (id) => {
    setLoading(true);
    CourseScheduleServices.changeStatus(id ?? '')
      .then(() => {
        getListSchedules(form);
      })
      .catch((err) =>
        toast.error(err?.message || err || '処理に失敗しました。もう一度お試しください。'),
      )
      .finally(() => setLoading(false));
  };

  const handleChangeStatus = async (id) => {
    const entry = schedules.items.find((item) => item._id === id);
    if (entry.status === 'CONFIRMED') {
      return;
    } else {
      const listStudent = await getListStudent(id);
      const isLessMinimumParticipants =
        entry.totalRegistrations < entry.minimumParticipants ||
        listStudent.length < entry.minimumParticipants;
      const courseName = entry.course?.name || entry.course?.officialName || '';
      const isCourseMat = courseName.includes('マット');

      if (isLessMinimumParticipants && !isCourseMat) {
        toast.error(
          'まだ最少催行人数に達していません。開催確定するには、最少催行人数を変更してください',
        );
        return;
      }

      if (isCourseMat) {
        setIsChangeStatus(id);
      } else {
        changeStatusDirect(id);
      }
    }
  };

  const columns = [
    {
      title: '開催ID',
      dataIndex: 'eventId',
      key: 'id',
      fixed: 'left',
      width: 100,
    },
    {
      title: 'コース名',
      dataIndex: 'courseName',
      key: 'courseName',
      fixed: 'left',
      width: 350,
      render: (_, record) => <div>{record.course.name}</div>,
    },
    {
      title: '開催日時',
      dataIndex: 'dates',
      key: 'dates',
      width: 205,
      render: (_, record) =>
        record.schedule.map((item, index) => (
          <div
            key={index}
            className="flex items-center"
          >{`${index + 1}日目: ${dayjs(item.startTime).format('YYYY/MM/DD')}`}</div>
        )),
    },
    {
      title: '講師',
      dataIndex: 'instructor',
      key: 'teacher',
      width: 142,
    },
    {
      title: '定員 (新規)',
      dataIndex: 'newCapacity',
      key: 'newCapacity',
      align: 'center',
      width: 137,
      render: (_, record) => <div>{`${record.totalNewStudents}/${record.newCapacity}`}</div>,
    },
    {
      title: '定員 (再受講)',
      dataIndex: 'retakeCapacity',
      key: 'retakeCapacity',
      align: 'center',
      width: 160,
      render: (_, record) =>
        record.schedule.map((item, index) => (
          <div key={index}>{`${item.count}/${record.retakeCapacity}`}</div>
        )),
    },
    {
      title: '最少催行',
      dataIndex: 'minimumParticipants',
      key: 'minimumParticipants',
      align: 'center',
      width: 136,
    },
    {
      title: 'ステータス',
      dataIndex: 'status',
      key: 'status',
      width: 152,
      render: (_, record) => (
        <div
          className={`option-cell flex h-[28px] items-center justify-center rounded-[4px] xl:text-[13px] 2xl:text-[13px] ${record.status === 'CONFIRMED' ? 'w-[90px] bg-[#E6F7FF] !text-[#1890FF]' : 'w-[90px] bg-[#FFF7E6] !text-[#FA8C16]'}`}
        >
          <div>{record.status === 'CONFIRMED' ? '開催確定' : '最小催行前'}</div>
        </div>
      ),
    },
    {
      title: 'アプリ表示',
      dataIndex: 'isVisible',
      key: 'isVisible',
      width: 120,
      render: (_, record) => {
        return (
          <div
            className={`option-cell flex h-[28px] items-center justify-center rounded-[4px] xl:text-[13px] 2xl:text-[13px] ${record.isVisible.toString() === 'true' ? 'w-[90px] bg-[#E6F7FF] !text-[#1890FF]' : 'w-[90px] bg-[#FFF7E6] !text-[#FA8C16]'}`}
          >
            <div>{record?.isVisible?.toString() === 'true' ? '公開' : '非公開'}</div>
          </div>
        );
      },
    },
    {
      title: 'QR管理',
      dataIndex: 'qrManagement',
      key: 'qrManagement',
      width: 156,
      render: (_, record) => (
        <div className="flex flex-col items-center gap-2 text-[14px]">
          <div
            onClick={() => setIsCourseDetail(record?._id)}
            className="flex h-[28px] w-[110px] cursor-pointer items-center justify-center rounded-[4px] bg-[#ED7836] !text-[#fff]"
          >
            受講者リスト
          </div>
          <div
            onClick={() =>
              setIsQRCode({
                courseId: record?._id,
                state: true,
              })
            }
            className="flex h-[28px] w-[110px] cursor-pointer items-center justify-center rounded-[4px] bg-[#00805A] !text-[#fff]"
          >
            QRコード管理
          </div>
        </div>
      ),
    },
    {
      title: 'アクション',
      dataIndex: 'action',
      key: 'action',
      width: 166,
      render: (_, record) => {
        return (
          <div style={{ display: 'flex', gap: '8px' }}>
            <div
              onClick={() => handleChangeStatus(record?._id)}
              className={`flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white ${record.status === 'CONFIRMED' ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
            >
              <images.visible.src />
            </div>
            <div
              onClick={() => handleVisibleChange({ id: record?._id })}
              className={`flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white cursor-pointer`}
            >
              <images.swap.src />
            </div>
            <div
              onClick={() => setIsEdit(record?._id)}
              className="flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer"
            >
              <images.edit.src />
            </div>
            <div
              onClick={() => handleSetDelete(record?._id)}
              className={`flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white ${schedules.items.find((item) => item._id === record._id)?.totalRegistrations !== 0 ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
            >
              <images.delete.src />
            </div>
          </div>
        );
      },
    },
  ];

  const handleVisibleChange = ({ id }) => {
    changeVisible(id);
  };

  const getCourses = (body = {}) => {
    setLoading(true);
    CourseScheduleServices.getCourses(body)
      .then((res) => {
        setCourses(
          res?.data
            .map((item) =>
              item.officialName !== 'インテグレーティッドトレーニング'
                ? { label: item.officialName, value: item._id }
                : {
                    label: 'インテグレーティッド',
                    value: item._id,
                  },
            )
            .filter((item) => item !== null) || [],
        );
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const changeVisible = (id) => {
    setLoading(true);
    CourseScheduleServices.changeVisible(id)
      .then((result) => {
        if (result.data) {
          getListSchedules({
            currentCourseStatus: 'UPCOMING_COURSES',
            ...form,
          });
        }
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getCourses();
  }, []);

  const handleChangeData = ({ label, value }) => {
    setForm({
      ...form,
      [label]: value,
    });
  };

  const getListSchedules = (body) => {
    CourseScheduleServices.getCourses(clearAllFields(body)).then((res) => {
      setSchedules({
        ...res.data,
        items: res.data.items.map((item, index) => ({
          ...item,
          key: item?._id || index,
        })),
      });
    });
  };

  const getRegions = () =>
    CourseServices.getCourses().then((res) => {
      setCourses(
        res.data.map((item) => ({
          value: item._id,
          label: item.name,
        })),
      );
    });

  useEffect(() => {
    getRegions();
  }, []);
  useEffect(() => {
    getListSchedules({
      currentCourseStatus: 'UPCOMING_COURSES',
      page: DEFAULT_PAGE_NUMBER,
      pageSize: DEFAULT_PAGE_SIZE,
      timezone: TIME_ZONE,
    });
  }, []);
  const handleSearch = () => {
    const body = {
      ...form,
      search: form.search?.trim(),
      status: form.status,
      currentCourseStatus: form.currentCourseStatus,
      region: form.region,
      course: form.course,
      page: DEFAULT_PAGE_NUMBER,
      pageSize: DEFAULT_PAGE_SIZE,
      startTime: form.dateStart && form.dateStart.replace(/\//g, '-'),
      endTime: form.dateEnd && form.dateEnd.replace(/\//g, '-'),
      timezone: TIME_ZONE,
    };

    getListSchedules(clearAllFields(body));
    setForm(body);
  };

  const handleDateChange = (dates, dateStrings) => {
    // dateStrings comes formatted by RangePicker per `format` prop (YYYY/MM/DD)
    if (!dates || !dateStrings) {
      setForm((prev) => ({
        ...prev,
        dateStart: '',
        dateEnd: '',
      }));
      return;
    }

    const [start, end] = dateStrings;
    setForm((prev) => ({
      ...prev,
      dateStart: start || '',
      dateEnd: end || '',
    }));
  };

  const handleChangePage = (page, pageSize) => {
    const body = {
      ...form,
      page,
      pageSize,
    };

    if (body.status === 'ALL') {
      delete body.status;
    }

    if (body.currentCourseStatus === 'ALL') {
      delete body.currentCourseStatus;
    }

    if (body.region === 'ALL') {
      delete body.region;
    }

    if (body.course === 'ALL') {
      delete body.course;
    }

    setForm(body);
    getListSchedules(body);
  };

  const handleAcceptDate = (e) => {
    // Only handle the click if it's from the calendar panel
    if (e?.target?.closest('.ant-picker-panel-container')) {
      const { start, end } = form;
      const dateRegex = /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;

      // If both dates are present and valid, update the form
      if (start && end && dateRegex.test(start) && dateRegex.test(end)) {
        // Trigger search with the selected dates
        setForm((prev) => ({
          ...prev,
          dateStart: start,
          dateEnd: end,
        }));
      } else {
        // Clear the dates if they're not valid
        setForm((prev) => ({
          ...prev,
          dateStart: '',
          dateEnd: '',
        }));
      }
    }
  };

  const handleAddCourse = () => setIsAddCourse(true);

  const handleOpenPopupSendEmailQRCode = (courseId, day) => {
    setIsSendEmailQRCode({
      state: true,
      courseId,
      day,
    });
  };

  return (
    <CourseScheduleWrapper>
      <Spin spinning={loading}>
        <div className="course-schedule flex w-full flex-col items-start justify-start gap-4">
          <div className="flex w-full items-start justify-between gap-4 filter xl:gap-4">
            <Select
              label="開催状況:"
              options={[
                {
                  label: '開催予定',
                  value: 'UPCOMING_COURSES',
                },
                {
                  label: '開催終了',
                  value: 'CLOSED_COURSE',
                },
              ]}
              value={form.currentCourseStatus}
              $width={220}
              $height={40}
              isPopup={false}
              onChange={(e) =>
                handleChangeData({
                  label: 'currentCourseStatus',
                  value: e.value,
                })
              }
              iconDown={images.icon.src}
            />

            <div className="flex w-max items-center justify-end gap-4 xl:max-w-[600px] xl:gap-4 2xl:gap-4">
              <Select
                label="コース:"
                value={form.course || 'ALL'}
                $width={220}
                $height={40}
                isPopup={false}
                $widthLabel={52}
                options={[
                  { value: 'ALL', label: '全て' },
                  ...courses.map((item) =>
                    item.label !== 'インテグレーティッドトレーニング'
                      ? {
                          value: item.value,
                          label: item.label,
                        }
                      : {
                          value: item.value,
                          label: 'インテグレーティッド',
                        },
                  ),
                ]}
                onChange={(e) =>
                  handleChangeData({
                    label: 'course',
                    value: e.value,
                  })
                }
                iconDown={images.icon.src}
              />

              <Select
                label="ステータス:"
                options={[
                  {
                    label: '全て',
                    value: 'ALL',
                  },
                  {
                    label: '開催確定',
                    value: 'CONFIRMED',
                  },
                  {
                    label: '最小催行前',
                    value: 'BEFORE_MINIMUM',
                  },
                ]}
                value={form.status || 'ALL'}
                $width={220}
                $height={40}
                isPopup={false}
                $widthLabel={74}
                onChange={(e) =>
                  handleChangeData({
                    label: 'status',
                    value: e.value,
                  })
                }
                iconDown={images.icon.src}
              />

              <ChooseDate
                label="日程:"
                start={form.dateStart}
                end={form.dateEnd}
                widthLabel={36}
                onChange={handleDateChange}
                onSubmit={handleAcceptDate}
                width={276}
                height={40}
                className={'xl:max-w-[247px]'}
              />
              <Button btnType="outline" width={84} height={40} onClick={handleSearch}>
                <p style={{ letterSpacing: '0' }}>検索</p>
              </Button>
            </div>
          </div>
          <Divider className="m-0" />

          <Button
            className="flex items-center"
            btnType="primary"
            width={120}
            height={40}
            onClick={handleAddCourse}
          >
            <p style={{ letterSpacing: '0' }}>追加</p>
          </Button>

          <Table
            columns={columns}
            dataSource={schedules?.items || []}
            rowKey="_id"
            pagination={false}
            scroll={{ x: 1575 }}
            tableLayout="auto"
            locale={{
              emptyText: <CustomEmptyDescription />,
            }}
          />

          <div className="flex w-full items-center justify-end">
            <Pagination
              total={schedules.count ?? 0}
              pageSize={form.pageSize}
              page={form.page}
              onChangePage={handleChangePage}
            />
          </div>
        </div>

        <ModalCourse
          isOpen={isAddCourse || !!isEdit}
          onClose={() => {
            setIsAddCourse(false);
            setIsEdit(null);
          }}
          onSuccess={() => {
            setForm({
              currentCourseStatus: 'UPCOMING_COURSES',
              page: DEFAULT_PAGE_NUMBER,
              pageSize: DEFAULT_PAGE_SIZE,
              timezone: TIME_ZONE,
            });
            getListSchedules({
              currentCourseStatus: 'UPCOMING_COURSES',
              page: DEFAULT_PAGE_NUMBER,
              pageSize: DEFAULT_PAGE_SIZE,
              timezone: TIME_ZONE,
            });
          }}
          onSuccessEdit={() => {
            const updatedForm = clearAllFields(form);
            if (schedules?.items?.length < 1 && form.page > 1) {
              updatedForm.page = form.page - 1;
            }
            setForm(updatedForm);
            getListSchedules(updatedForm);
          }}
          isEdit={!!isEdit}
          courseId={isEdit}
        />

        <ModalCourseDetail
          isOpen={!!isCourseDetail}
          onClose={() => {
            setIsCourseDetail(null);
          }}
          onSuccess={() => setIsCourseDetail(null)}
          courseId={isCourseDetail}
        />

        <ModalQRCode
          isOpen={isQRCode.state && !!isQRCode.courseId}
          onCancel={() => setIsQRCode({ state: false, courseId: null })}
          courseId={isQRCode.courseId}
          onSendEmail={handleOpenPopupSendEmailQRCode}
        />

        {/* <SendEmailQRCodePopup
          isOpen={isSendEmailQRCode.courseId && isSendEmailQRCode.state}
          onCancel={() =>
            setIsSendEmailQRCode({ state: false, courseId: null })
          }
          courseId={isSendEmailQRCode.courseId}
          day={isSendEmailQRCode.day}
          onChange={handleChangeDataSendEmail}
          initialState={initialSendEmailState}
          form={sendEmailForm}
          onConfirmSendEmail={handleOpenPopupConfirmEmailQRCode}
          onReset={handleResetSendEmailForm}
        />

        <ConfirmEmailQRCode
          isOpen={isConfirmEmailQRCode.state && !!isConfirmEmailQRCode.courseId}
          onCancel={() => {
            setIsConfirmEmailQRCode({
              ...isConfirmEmailQRCode,
              state: false,
            });
          }}
          loading={loadingSendEmail}
          form={sendEmailForm}
          onBack={() => {
            setIsSendEmailQRCode({
              ...isSendEmailQRCode,
              state: true,
            });
            setIsConfirmEmailQRCode({
              ...isConfirmEmailQRCode,
              state: false,
            });
          }}
          onSuccess={handleConfirmSendEmailQRCode}
          courseId={isConfirmEmailQRCode.courseId}
        /> */}

        <ModalConfirmChangeStatus
          isOpen={!!isChangeStatus}
          onCancel={() => setIsChangeStatus(null)}
          onSuccess={() => {
            setIsChangeStatus(null);
            getListSchedules(form);
          }}
          courseId={isChangeStatus}
        />

        <ModalConfirmDeleteSchedule
          isOpen={!!isDelete}
          onCancel={() => {
            setIsDelete(null);
          }}
          onSuccess={() => {
            setIsDelete(null);
            const updatedForm = clearAllFields(form);
            // If we're not on the first page and this is the last item on the current page
            if (schedules?.items?.length === 1 && form.page > 1) {
              updatedForm.page = form.page - 1; // Go to previous page
            }
            setForm(updatedForm);
            getListSchedules(updatedForm);
          }}
          courseId={isDelete}
        />
      </Spin>
    </CourseScheduleWrapper>
  );
};

export default CourseSchedule;
